import React, {useContext, useEffect, useState} from "react";
import {FormHelperText} from "@material-ui/core";
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import { get } from "@api/category"
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from "@mui/material/Typography/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import OutlinedInput from "@mui/material/OutlinedInput/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment/InputAdornment";
import {FormControl} from "@mui/material";
import EllipsisText from "react-ellipsis-text";
import {InputLabel} from "@material-ui/core";

const useStyles = makeStyles({
    body: {
        padding: '5px 0',
        position: 'relative'
    },
    root:{
        display: 'flex',
        justifyContent: 'space-between'
    },
    textLabel: {
        position: 'absolute',
        top: '-20px',
        background: '#fff',
        padding: '0 3px',
        fontSize: '10px',
    },
    subCategory: {
        textTransform: 'capitalize',
        marginLeft: 0,
    },
    outline: {
        marginBottom: '20px',
    },
    main: {
        padding: '20px',
        minWidth: '220px'
    },
    title: {
        fontWeight: 'bold',
        marginBottom: '20px',
    },
    category: {
        fontWeight: 'bold',
        textTransform: 'capitalize',
        marginLeft: 0,
    },
    categoryTitle: {
        fontWeight: 'bold',
        textTransform: 'capitalize'
    },
    subCategoriesTitle: {
        textTransform: 'capitalize'
    },
});

export default (data, key) => {
    const classes = useStyles();
    const [category, setCategory] = useState({})
    const [categories, setCategories] = useState([])
    const [init, setInit] = useState(false)
    const {setLoading} = useContext(LoadingContext);
    const {setErrorMessage} = useContext(MessageContext);

    const clearCheckboxes = (categoriesObj = categories) => {
        categoriesObj.forEach((category) => {
            category.choose = false
            category.subCategories.forEach((subCategory) => {
                subCategory.choose = false
            })
        })

        setCategories([...categoriesObj])
    }

    const onChange = (event, id) => {
        event.preventDefault();
        const name = event.target.name
        clearCheckboxes()
        if(category.id === id){ return setCategory({})}

        categories.forEach((category) => {
            if(id === category.id){
                const choose = !category[name]
                category[name] = choose
            }
        })

        setCategories([...categories])
    };

    const onChangeSubCategpries = (event, id, idSub) => {
        event.preventDefault();
        const name = event.target.name
        clearCheckboxes()

        if(category.id === id || category.id === idSub){ return setCategory({})}

        categories.forEach((category) => {
            if(id === category.id){
                category.subCategories.forEach((subCategory) => {
                    if(subCategory.id === idSub){
                        subCategory[name] = !subCategory[name]
                    }
                })
            }
        })

        setCategories([...categories])
    };

    useEffect(() => {
        const loadCategory = async () => {
            try {
                setLoading(true);
                setErrorMessage(null);

                const [categories] = await get()
                clearCheckboxes(categories)

                if(data.value){
                    const id = data.value.id
                    const name = 'choose'

                    categories.forEach((category) => {
                        if(id === category.id){
                            const choose = !category[name]
                            category[name] = choose
                        }

                        category.subCategories.forEach((subCategory) => {
                            if(subCategory.id === id){
                                subCategory[name] = !subCategory[name]
                            }
                        })
                    })
                }

                setInit(true)
                setCategories(categories)
            } catch (e) {
                setErrorMessage(e);
            }
            setLoading(false);
        }

        loadCategory()
    }, [setLoading, setErrorMessage])

    useEffect(() => {
        const findActiveCategory = () => {
            let categoryValue = null

            categories.forEach((category) => {
                if(category.choose){
                    categoryValue = category
                }
                category.subCategories.forEach((subCategory) => {
                    if(subCategory.choose){
                        categoryValue = subCategory
                    }
                })
            })

            if(categoryValue){
                setCategory({...categoryValue})
            }
        }

        findActiveCategory()
    }, [categories])

    useEffect(() => {
        if(init){
            data.onCallback({
                target:{
                    name: data.name,
                    value: category
                }
            })
        }
    }, [category, init, data])

    return (
        <FormControl fullWidth key={key} error={data.error ? true : false}>
            <PopupState variant="popover" popupId="categories">
                {(popupState) => (
                    <Box key={'categories-segment'} className={classes.body}>
                        <InputLabel className={classes.textLabel} htmlFor="category" variant="filled">
                            Category
                        </InputLabel>
                        <OutlinedInput
                            id={'category'}
                            fullWidth
                            value={data.value.name}
                            endAdornment={<InputAdornment position="end"><Button
                                {...bindTrigger(popupState)}
                                variant="text">Choose</Button></InputAdornment>}
                        />
                        <Popover
                            {...bindPopover(popupState)}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                        >
                            <FormGroup className={classes.main} key={key}>
                                <Typography className={classes.title} fontSize={14} component="h3">Choose category</Typography>
                                {categories.length && categories.map((category, ind) => (
                                    <Box key={'category' + ind} className={classes.outline}>
                                        <FormControlLabel
                                            classes={classes}
                                            labelPlacement="start"
                                            key={category.id + ind}
                                            className={classes.category}
                                            control={<Checkbox disabled={
                                                (category.subCategories.filter(({active}) => active).length && category.subCategories.length > 0) ||
                                                (category.subCategories.filter(({active}) => !active).length === category.subCategories.length && category.subCategories.length > 0)
                                            } name='choose'
                                            checked={category.choose} />}
                                            onClick={(e) => onChange(e, category.id)}
                                            label={<Typography className={classes.categoryTitle} fontSize={14} variant="h6"><EllipsisText text={category.name} length={20} /></Typography>}
                                        />
                                        {category.subCategories.map(({id, choose, name}, ind) => (
                                            <FormControlLabel
                                                classes={classes}
                                                key={id + ind}
                                                labelPlacement="start"
                                                label={<Typography className={classes.subCategoriesTitle} fontSize={14} variant="h6"><EllipsisText text={name} length={20} /></Typography>}
                                                className={classes.subCategory}
                                                control={<Checkbox name='choose' checked={choose} />}
                                                checked={choose}
                                                onClick={(e) => onChangeSubCategpries(e, category.id, id)} />
                                        ))}
                                    </Box>
                                ))}

                                {data.error && (<FormHelperText>{data.error}</FormHelperText>)}
                            </FormGroup>
                        </Popover>
                    </Box>
                )}
            </PopupState>
        </FormControl>
    );
}